import ParameterFieldBase, { IParameterFieldBaseOptions } from './ParameterFieldBase';
import { default as EditComponent } from '../tsx/PaletteListField';

export class PaletteListField extends ParameterFieldBase<IParameterFieldBaseOptions> {
    public static defaultValidators = [];

    public static EditComponent = EditComponent;

    constructor(
        glob,
        title: string,
        validators?: any,
        defaultVal: any = null,
        options?: {
            [key: string]: any;
            onChange?: (values, value) => any;
        }
    ) {
        super(glob, title, PaletteListField.defaultValidators, validators, defaultVal, options);
    }
}
